Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentInstagramMediaView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_instagram_media"]
  className: 'sc-media'

  initialize: (options = {}) ->
    @image = options.image
    @fullImage = options.fullImage
    @video = if typeof(options.video) == 'object' then options.video.url else options.video

  render: ->
    @$el.html @template { @image, @fullImage, @video }
    this
